import { formatLeverageDisplay } from '@flipster/features/src/shared/position/leverage';
import type { OpenPosition } from '@flipster/r230522/normal-sub/tables/private/positions';
import type { OpenPosition as LegacyOpenPosition } from '@flipster/r230522/original/position';
import { useLocalStorage } from '@flipster/react/misc/state/use-local-storage';

export { formatLeverageDisplay } from '@flipster/features/src/shared/position/leverage';
export type { DisplayedLeverageType } from '@flipster/features/src/shared/position/leverage';

export function useDisplayedLeverage() {
  return useLocalStorage({
    key: 'flipster.configs.v1.displayed_leverage_type',
    defaultValue: 'positionLeverage',
  });
}

export function useLeverageDisplayValue(position: LegacyOpenPosition | OpenPosition | undefined) {
  const [displayedLeverage] = useDisplayedLeverage();
  return formatLeverageDisplay(displayedLeverage, position);
}
